import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import {
  CreateCongregation,
  CongregationCreated,
  createCongregation,
} from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useCreateCongregation = (
  options: UseMutationOptions<
    CongregationCreated,
    unknown,
    CreateCongregation,
    unknown
  >
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (congregation) => {
      const result = await extractData(
        createCongregation({ body: congregation })
      );
      return result;
    },
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['congregations'],
      });
      options.onSuccess?.(...args);
    },
  });
};
